import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { PublicidadService } from '../publicidad.service';

@Component({
  selector: 'app-publicidad-preview',
  templateUrl: './publicidad-preview.component.html',
  styleUrls: ['./publicidad-preview.component.scss']
})
export class PublicidadPreviewComponent implements OnInit {
  @Input() element: any;
  @Input() imgFile: any;

  constructor(
    public activeModal: NgbActiveModal,
    public service: PublicidadService,
    public formatter: FormatterService,
  ) { }

  ngOnInit(): void {
  }

}
